import { createContext, useContext, useState } from 'react';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';
import { API } from '../constants/fetchApiConfig';

const GoogleAccessPolicyContext = createContext({
  loading: true,
  statusMessage: '',
  getCalendarSyncStatus: (authCode: string) => {}
});

export const GoogleAccessPolicyProvider = (props) => {
  const { setErrorCode } = useApiError();
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const getCalendarSyncStatus = async(authCode: string) => {
    try {
        setLoading(true);
        const response = await API.get(authCode, '/calendar/sync/status');
        const data = await response.json();
        setStatusMessage(data);
        setLoading(false);
    } 
    catch(e: any) {
        setLoading(false);
        if(e.response?.status) setErrorCode(e.response?.status);
        else setErrorCode(error.DEFAULT);
    }
  }

  return (
    <GoogleAccessPolicyContext.Provider
      value={{
        loading,
        statusMessage,
        getCalendarSyncStatus
      }}>
      {props.children}
    </GoogleAccessPolicyContext.Provider>
  );
};

export const useGoogleAccessPolicyProvider = () => {
  return useContext(GoogleAccessPolicyContext);
};

